module.exports = __webpack_public_path__ + "img/w3_exclamation_dark.3185cb0b.png";